import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { publicApi } from "@/lib/account";
import { EXTRA } from "@/lib/i18n_extra";

export const LANGS = [
  { code: "en", label: "English" }, { code: "hi", label: "हिन्दी" }, { code: "ar", label: "العربية" },
  { code: "es", label: "Español" }, { code: "fr", label: "Français" },
];

const D = {
  en: {
    browse: "Browse", countries: "Countries", plans: "Plans", interests: "Interests", chat: "Messages", shortlist: "Shortlist",
    stories: "Stories", me: "My Profile", invite: "Invite", admin: "Admin", signin: "Sign in", wallet: "Wallet",
    kicker: "One world · Every culture · One love", t1: "Love knows no ", t2: "borders", t3: ". Find your forever, anywhere.",
    sub: "A global marriage community for every nationality, faith and ethnicity — cross-cultural and international matches welcome. Free profile, trial from ₹9.",
    browseBtn: "Browse profiles", createBtn: "Create your profile", plansTitle: "Subscription plans",
    plansSub: "A subscription unlocks chat. Messages cost ₹1 within your country and ₹30 across borders — each plan includes chat credit.",
    subscribe: "Subscribe", startTrial: "Start trial", extend: "Extend plan", browseTitle: "Browse profiles", sendMsg: "Send a message",
    writeMsg: "Write a thoughtful message...", match: "match", spotlight: "Couple of the week", readStories: "Read all stories",
    crossBorder: "Cross-border chat", perMsg: "per message",
  },
  hi: {
    browse: "प्रोफ़ाइल देखें", countries: "देश", plans: "प्लान", interests: "रुचियाँ", chat: "संदेश", shortlist: "शॉर्टलिस्ट",
    stories: "कहानियाँ", me: "मेरी प्रोफ़ाइल", invite: "आमंत्रण", admin: "एडमिन", signin: "साइन इन", wallet: "वॉलेट",
    kicker: "एक दुनिया · हर संस्कृति · एक प्यार", t1: "प्यार की कोई ", t2: "सीमा", t3: " नहीं। अपना जीवनसाथी कहीं भी खोजें।",
    sub: "हर राष्ट्रीयता, धर्म और समुदाय के लिए वैश्विक विवाह समुदाय — अंतर-सांस्कृतिक और अंतरराष्ट्रीय रिश्ते स्वागत योग्य। मुफ़्त प्रोफ़ाइल, ट्रायल ₹9 से।",
    browseBtn: "प्रोफ़ाइल देखें", createBtn: "अपनी प्रोफ़ाइल बनाएँ", plansTitle: "सदस्यता प्लान",
    plansSub: "सदस्यता से चैट खुलती है। देश के भीतर संदेश ₹1, देश के बाहर ₹30 — हर प्लान में चैट क्रेडिट शामिल।",
    subscribe: "सदस्यता लें", startTrial: "ट्रायल शुरू करें", extend: "प्लान बढ़ाएँ", browseTitle: "प्रोफ़ाइल देखें", sendMsg: "संदेश भेजें",
    writeMsg: "एक सुंदर संदेश लिखें...", match: "मेल", spotlight: "इस सप्ताह का जोड़ा", readStories: "सभी कहानियाँ पढ़ें",
    crossBorder: "अंतरराष्ट्रीय चैट", perMsg: "प्रति संदेश",
  },
  ar: {
    browse: "تصفح", countries: "الدول", plans: "الباقات", interests: "الاهتمامات", chat: "الرسائل", shortlist: "المفضلة",
    stories: "قصص النجاح", me: "ملفي", invite: "ادعُ صديقًا", admin: "الإدارة", signin: "تسجيل الدخول", wallet: "المحفظة",
    kicker: "عالم واحد · كل الثقافات · حب واحد", t1: "الحب لا يعرف ", t2: "حدودًا", t3: ". ابحث عن شريك حياتك في أي مكان.",
    sub: "مجتمع زواج عالمي لكل الجنسيات والأديان والأعراق — نرحب بالزواج بين الثقافات والدول. ملف مجاني وتجربة تبدأ من ₹9.",
    browseBtn: "تصفح الملفات", createBtn: "أنشئ ملفك", plansTitle: "باقات الاشتراك",
    plansSub: "الاشتراك يفتح المحادثة. الرسالة داخل بلدك ₹1 وبين الدول ₹30 — كل باقة تشمل رصيد محادثة.",
    subscribe: "اشترك", startTrial: "ابدأ التجربة", extend: "مدد الباقة", browseTitle: "تصفح الملفات", sendMsg: "أرسل رسالة",
    writeMsg: "اكتب رسالة لطيفة...", match: "توافق", spotlight: "ثنائي الأسبوع", readStories: "اقرأ كل القصص",
    crossBorder: "محادثة دولية", perMsg: "لكل رسالة",
  },
  es: {
    browse: "Explorar", countries: "Países", plans: "Planes", interests: "Intereses", chat: "Mensajes", shortlist: "Favoritos",
    stories: "Historias", me: "Mi perfil", invite: "Invitar", admin: "Admin", signin: "Iniciar sesión", wallet: "Monedero",
    kicker: "Un mundo · Todas las culturas · Un amor", t1: "El amor no conoce ", t2: "fronteras", t3: ". Encuentra a tu persona, en cualquier lugar.",
    sub: "Una comunidad matrimonial global para todas las nacionalidades, religiones y etnias — bienvenidas las parejas interculturales e internacionales. Perfil gratis, prueba desde ₹9.",
    browseBtn: "Ver perfiles", createBtn: "Crea tu perfil", plansTitle: "Planes de suscripción",
    plansSub: "La suscripción desbloquea el chat. Mensajes a ₹1 en tu país y ₹30 entre países — cada plan incluye crédito.",
    subscribe: "Suscribirse", startTrial: "Empezar prueba", extend: "Ampliar plan", browseTitle: "Explorar perfiles", sendMsg: "Enviar mensaje",
    writeMsg: "Escribe un mensaje bonito...", match: "afinidad", spotlight: "Pareja de la semana", readStories: "Leer todas las historias",
    crossBorder: "Chat internacional", perMsg: "por mensaje",
  },
  fr: {
    browse: "Parcourir", countries: "Pays", plans: "Formules", interests: "Intérêts", chat: "Messages", shortlist: "Favoris",
    stories: "Histoires", me: "Mon profil", invite: "Inviter", admin: "Admin", signin: "Connexion", wallet: "Portefeuille",
    kicker: "Un monde · Toutes les cultures · Un amour", t1: "L'amour n'a pas de ", t2: "frontières", t3: ". Trouvez l'âme sœur, où qu'elle soit.",
    sub: "Une communauté mondiale du mariage pour toutes les nationalités, religions et origines — unions interculturelles et internationales bienvenues. Profil gratuit, essai dès ₹9.",
    browseBtn: "Voir les profils", createBtn: "Créer mon profil", plansTitle: "Formules d'abonnement",
    plansSub: "L'abonnement débloque le chat. Message à ₹1 dans votre pays, ₹30 entre pays — chaque formule inclut du crédit.",
    subscribe: "S'abonner", startTrial: "Commencer l'essai", extend: "Prolonger", browseTitle: "Parcourir les profils", sendMsg: "Envoyer un message",
    writeMsg: "Écrivez un joli message...", match: "affinité", spotlight: "Couple de la semaine", readStories: "Lire toutes les histoires",
    crossBorder: "Chat international", perMsg: "par message",
  },
};

const REGION_CURRENCY = { US: "USD", GB: "GBP", CA: "CAD", AU: "AUD", NZ: "NZD", AE: "AED", SA: "SAR", QA: "QAR", KW: "KWD", OM: "OMR",
  EG: "EGP", NG: "NGN", KE: "KES", ZA: "ZAR", BR: "BRL", MX: "MXN", AR: "ARS", JP: "JPY", CN: "CNY", KR: "KRW", PH: "PHP",
  ID: "IDR", MY: "MYR", SG: "SGD", TH: "THB", PK: "PKR", BD: "BDT", LK: "LKR", NP: "NPR", TR: "TRY", RU: "RUB", CH: "CHF",
  SE: "SEK", NO: "NOK", DK: "DKK", PL: "PLN", IN: "INR" };
const EURO = ["DE", "FR", "IT", "ES", "NL", "IE", "PT", "BE", "AT", "FI", "GR"];
export const CURRENCIES = ["INR", "USD", "EUR", "GBP", "AED", "SAR", "CAD", "AUD", "SGD", "NGN", "KES", "ZAR", "BRL", "MXN", "JPY", "CNY", "KRW", "PHP", "IDR", "TRY", "RUB", "EGP", "SEK", "CHF", "PKR", "BDT"];

const detectCurrency = () => {
  const region = (navigator.language || "en-IN").split("-")[1]?.toUpperCase();
  if (EURO.includes(region)) return "EUR";
  return REGION_CURRENCY[region] || "INR";
};

const Ctx = createContext(null);

export function PrefsProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("vr_lang") || "en");
  const [currency, setCurrency] = useState(localStorage.getItem("vr_cur") || detectCurrency());
  const [rates, setRates] = useState(null);
  useEffect(() => { publicApi.get("/fx").then((r) => setRates(r.data.rates)).catch(() => {}); }, []);
  useEffect(() => {
    localStorage.setItem("vr_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  useEffect(() => { localStorage.setItem("vr_cur", currency); }, [currency]);
  const value = useMemo(() => ({
    lang, setLang, currency, setCurrency,
    t: (k) => EXTRA[lang]?.[k] ?? D[lang]?.[k] ?? EXTRA.en[k] ?? D.en[k] ?? k,
    local: (inr) => {
      if (currency === "INR" || !rates?.[currency]) return null;
      const v = inr * rates[currency];
      return "≈ " + new Intl.NumberFormat(undefined, { style: "currency", currency, maximumFractionDigits: v < 10 ? 2 : 0 }).format(v);
    },
  }), [lang, currency, rates]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const usePrefs = () => useContext(Ctx);
